import type { LawType } from '@/types/law'
import { LAW_TYPE_LABELS } from '@/types/law'

type FilterType = LawType | 'all'

interface Props {
  active: FilterType
  onChange: (type: FilterType) => void
  counts?: Partial<Record<FilterType, number>>
}

const TABS: { key: FilterType; emoji: string }[] = [
  { key: 'all',    emoji: '🔍' },
  { key: 'law',    emoji: '📜' },
  { key: 'prec',   emoji: '⚖️' },
  { key: 'admrul', emoji: '📋' },
  { key: 'ordin',  emoji: '🏛' },
  { key: 'cnstc',  emoji: '🔴' },
]

const LABELS: Record<FilterType, string> = {
  all: '전체',
  ...LAW_TYPE_LABELS,
}

export default function FilterTabs({ active, onChange, counts }: Props) {
  return (
    <div className="flex gap-1 p-1 bg-gray-100 rounded-xl overflow-x-auto">
      {TABS.map(({ key, emoji }) => {
        const isActive = active === key
        const count = counts?.[key]
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            className={`
              flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium
              whitespace-nowrap transition-all
              ${isActive
                ? 'bg-white text-law-700 shadow-sm'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }
            `}
          >
            <span>{emoji}</span>
            <span>{LABELS[key]}</span>
            {count !== undefined && count > 0 && (
              <span className={`text-xs px-1.5 py-0.5 rounded-full font-semibold
                ${isActive ? 'bg-law-100 text-law-600' : 'bg-gray-200 text-gray-500'}`}>
                {count > 999 ? '999+' : count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
